import { create } from "zustand";
import { combine, createJSONStorage, persist } from "zustand/middleware";
import { adminStore } from "./admin.store";
export const authStore = create(
  persist(
    combine(
      {
        token: null,
        refreshToken: null,
        refreshTokenExpiryTime: null,
        refreshPending: false,
        redirectPath: null,
      },
      (set, get) => ({
        setToken: (token) => set({ token }),
        setAuthTokens: ({ token, refreshToken, refreshTokenExpiryTime }) => {
          set({
            token,
            refreshToken,
            refreshTokenExpiryTime,
          });
        },
        setRefreshToken: (resp) => {
          set({
            token: resp.token,
            refreshToken: resp.refreshToken,
            refreshTokenExpiryTime: resp.refreshTokenExpiryTime,
            refreshPending: false,
          });
        },
        setRedirectPath: (path) => set({ redirectPath: path }),
        clearRedirectPath: () => set({ redirectPath: null }),
        reset: () => {
          set({
            token: null,
            refreshToken: null,
            refreshTokenExpiryTime: null,
            refreshPending: false,
            redirectPath: null,
          });

          adminStore.getState().setUserProfile(null);
        },
      })
    ),
    { name: "park-pay-auth", storage: createJSONStorage(() => sessionStorage) }
  )
);
